module.exports = __webpack_public_path__ + "img/管理-4.97a1cfa3.jpg";